import { render, staticRenderFns } from "./drag_video.vue?vue&type=template&id=628dd90c&scoped=true&"
import script from "./drag_video.vue?vue&type=script&lang=js&"
export * from "./drag_video.vue?vue&type=script&lang=js&"
import style0 from "./drag_video.vue?vue&type=style&index=0&id=628dd90c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628dd90c",
  null
  
)

export default component.exports